import React, { Component } from "react"

import Header from '../../components/Header/Header';
import Content_CuentaAmibus from "./Content_CuentaAmibus";
import Footer from '../../components/Footer/Footer';

class CuentaAmibus extends Component {
    render() {
        return (

            <div class="main-container">
                <Header />
                <Content_CuentaAmibus />
                <Footer />
            </div>

        )
    }
}

export default CuentaAmibus;